import { useEffect, useRef, useState } from "react";
import { ScanBarcode } from "lucide-react";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Barcode field: a USB or Bluetooth reader types like a keyboard and ends
// with Enter. With autoFocus it takes the focus back after each code, so
// the next shot lands here; typing the code by hand works the same.
export const ScanField = ({
  id,
  label,
  onCode,
  autoFocus = false,
}: {
  id: string;
  label: string;
  onCode: (code: string) => void;
  autoFocus?: boolean;
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState("");

  useEffect(() => {
    if (autoFocus) ref.current?.focus();
  }, [autoFocus]);

  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id} className="flex items-center gap-1.5">
        <ScanBarcode className="size-4" />
        {label}
      </Label>
      <Input
        id={id}
        ref={ref}
        value={value}
        autoComplete="off"
        onChange={(event) => setValue(event.target.value)}
        onKeyDown={(event) => {
          if (event.key !== "Enter") return;
          event.preventDefault();
          if (value.trim()) onCode(value.trim());
          setValue("");
        }}
      />
    </div>
  );
};
